import globalStore from "@/store";

const cattle = {
  namespaced: true,
  state: {
    cattle: [],
    latestDataForAllCattle: [],
    cowMovingHistoryObject: {},
    cattleForAutoSuggest: [],
    cow: {
      pkCowId: 0,
      name: "",
      color: null,
      fkDeviceId: "",
      earringNumber: "",
      canBeDeleted: true,
      customMarked: false,
      showOnMap: true,
    },
    unlinkedCattle: [],
    unlinkedDevices: [],
    center: { lat: 43.823728, lng: 18.374197 },
  },
  actions: {
    GET_ALL_CATTLE: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/cattle")
          .then(function(response) {
            globalStore.commit("cattle/SET_CATTLE", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_COW_BY_ID: function({ state }, id) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/cattle/" + id)
          .then(function(response) {
            globalStore.commit("cattle/SET_COW", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    ADD_COW: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/cattle", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    UPDATE_COW: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .put("/cattle", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    DELETE_COW: function({ state }, id) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .delete("/cattle/" + id)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_ALL_UNLINKED_CATTLE_AND_DEVICES: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/cattle/GetAllUnlinkedCattleAndDevices")
          .then(function(response) {
            globalStore.commit(
              "cattle/SET_UNLINKED_CATTLE",
              response.data.unlinkedCattle
            );
            globalStore.commit(
              "cattle/SET_UNLINKED_DEVICES",
              response.data.unlinkedDevices
            );
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    LINK_COW_AND_DEVICE: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/cattle/LinkCowAndDevice", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    UNLINK_DEVICE: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/cattle/UnlinkDevice", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_LATEST_DATA_FOR_ALL_CATTLE: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/cattle/GetLatestPositionForAllCattle")
          .then(function(response) {
            globalStore.commit(
              "cattle/SET_LATEST_DATA_FOR_ALL_CATTLE",
              response.data
            );
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_ALL_CATTLE_FOR_AUTO_SUGGEST: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/cattle/GetAllCattleForAutoSuggest")
          .then(function(response) {
            globalStore.commit(
              "cattle/SET_CATTLE_FOR_AUTO_SUGGEST",
              response.data
            );
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_COW_MOVING_HISTORY: function({ state }, model) {
      if (
        model.cow == null &&
        (model.dateFrom == null || model.dateFrom == "") &&
        model.dateTo == null
      )
        return;

      let path = "/cattle/GetMovingHistoryForCow";
      let path2 = "/cattle/GetMovingHistoryForCowLatestPositionOnly";
      if (model.cow == null && model.dateFrom == null && model.dateTo != null)
        path = path2;
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post(path, model)
          .then(function(response) {
            globalStore.commit("cattle/SET_COW_MOVING_HISTORY", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
  },
  mutations: {
    SET_CATTLE: function(state, model = null) {
      model == null ? (state.cattle = []) : (state.cattle = model);
    },
    SET_UNLINKED_CATTLE: function(state, model = null) {
      model == null
        ? (state.unlinkedCattle = [])
        : (state.unlinkedCattle = model);
    },
    SET_LATEST_DATA_FOR_ALL_CATTLE: function(state, model = null) {
      model == null
        ? (state.latestDataForAllCattle = [])
        : (state.latestDataForAllCattle = model);
    },
    SET_CATTLE_FOR_AUTO_SUGGEST: function(state, model = null) {
      model == null
        ? (state.cattleForAutoSuggest = [])
        : (state.cattleForAutoSuggest = model);
    },
    SET_COW_MOVING_HISTORY: function(state, model = null) {
      model == null
        ? (state.cowMovingHistoryObject = {})
        : (state.cowMovingHistoryObject = model);
    },
    SET_UNLINKED_DEVICES: function(state, model = null) {
      model == null
        ? (state.unlinkedDevices = [])
        : (state.unlinkedDevices = model);
    },
    SET_COW: function(state, model = null) {
      model == null
        ? (state.cow = {
            pkCowId: 0,
            name: "",
            color: null,
            fkDeviceId: "",
            earringNumber: "",
            canBeDeleted: true,
          })
        : (state.cow = model);
    },
    SET_CENTER: function(state, model = null) {
      model == null
        ? (state.center = { lat: 43.55164693977359, lng: 18.49494254514075 })
        : (state.center = model);
    },
  },
};
export default cattle;
